<div class="row bg-secondary-nvwa">
  <div class="container">
    <h3 class="pt-3">
      {{ "DOWNLOAD_EPHYTO.NIET_GEVONDEN_HEADER" | promptvalue | async }}
    </h3>
  </div>
</div>
<div class="container">
  <div class="py-5">
    {{ "DOWNLOAD_EPHYTO.NIET_GEVONDEN_TEKST" | promptvalue | async }}
  </div>
</div>
